import { get, post } from '@/utils/request/mAxios';
import APIs from './index';
import {
  UpdateTeam,
  CreateTeam,
  DeleteTeam,
  TeamListQuery,
  TransformTeam,
} from '@/pages/business/types';

export function getTeamList(data: TeamListQuery) {
  return get(APIs.getTeamList, data);
}

export function createTeam(data: CreateTeam) {
  return post(APIs.createTeam, data);
}

export function updateTeam(data: UpdateTeam) {
  return post(APIs.updateTeam, data);
}

export function deleteTeam(data: DeleteTeam) {
  return post(APIs.deleteTeam, data);
}

export function transformTeam(data: TransformTeam) {
  return post(APIs.transformTeam, data);
}
